/* global IS_PRODUCTION */

import { get } from 'lodash-es'
import axios from 'axios'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'
// import { getLinkUrl } from './links-helper'

let globalAxios = axios
let theStore = undefined

export const setDefaultAxiosInterceptor = store => {
  theStore = store
  // console.log('axios helper store', theStore)
  if (!IS_PRODUCTION) {
    // PLEASE NOTE:
    console.log('Not in production. Not using axios logout time interceptor.')
    return
  }

  const countdownLogoutTime = get(store, [
    'state',
    STORE_MODULES.APP,
    APP_CONSTANTS.COUNTDOWN_LOGOUT_TIME,
  ])
  const baseUrl = get(store, `state.${STORE_MODULES.APP}.${APP_CONFIG_CONSTANTS.PATHS.BASE_URL}`)
  const excludedUrls = [
    `${store.getters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_STATUS_URL}`]}`,
    `${store.getters[`${STORE_MODULES.APP}/${APP_GETTER.BLOCKINGREASON_URL}`]}`,
    `${
      store.getters[`${STORE_MODULES.APP}/${APP_GETTER.BU_NEWS_BASE_URL}`]
    }?activePage=1&itemsPerPage=1`,
  ]

  globalAxios.interceptors.response.use(
    function (response) {
      const url = response?.config?.url

      const isExcludedTypo3Url = excludedUrls.includes(url)

      if (isExcludedTypo3Url) {
        // console.log('Ignore exluded url')
        return response
      }

      const isTypo3System = !url.startsWith('http') || url.startsWith(baseUrl)
      if (isTypo3System && countdownLogoutTime) {
        store.dispatch(
          `${STORE_MODULES.APP}/${APP_ACTIONS.SET_CURRENT_LOGOUT_TIME}`,
          countdownLogoutTime,
          { root: true },
        )
      }
      return response
    },
    // function (error) {
    //   // Any status codes that falls outside the range of 2xx cause this function to trigger
    //   // Do something with response error
    //   return Promise.reject(error)
    // },
  )
}

export const getAppStoreUrl = getterName => {
  console.log(
    'axios helper getAppStoreUrl store',
    theStore,
    getterName,
    theStore.getters[`${STORE_MODULES.APP}/${getterName}`],
  )
  return theStore.getters[`${STORE_MODULES.APP}/${getterName}`]
}
export default globalAxios
